import { Accordion, Typography } from '@equinor/eds-core-react'
import { StreamingLog } from '../../../components/code/log'
import { getPipelineJobStepLogsStreamUrl } from '../../../store/eventstream-log-api'
import { radixApi, type Step, useGetPipelineJobStepLogsQuery } from '../../../store/radix-api'
import { getFetchErrorCode } from '../../../store/utils/parse-errors'
import { HistoricalLog } from './HistoricalLog'

import '../style.css'
import AsyncResource from '../../../components/async-resource/async-resource'

interface StepLogsProps {
  appName: string
  jobName: string
  step: Pick<Step, 'name'>
}

export function JobStepLogs({ appName, jobName, step }: StepLogsProps) {
  const [getLog] = radixApi.endpoints.getPipelineJobStepLogs.useLazyQuery()
  const state = useGetPipelineJobStepLogsQuery(
    { appName, jobName, stepName: step.name, lines: '1' },
    { skip: !appName || !jobName || !step.name, pollingInterval: 0 }
  )
  const eventStreamUrl = getPipelineJobStepLogsStreamUrl(appName, jobName, step.name)
  const notFound = state.isError && getFetchErrorCode(state.error) === 404

  return (
    <Accordion className="accordion elevated" chevronPosition="right">
      <Accordion.Item isExpanded>
        <Accordion.Header>
          <Accordion.HeaderTitle>
            <Typography variant="h4">Log</Typography>
          </Accordion.HeaderTitle>
        </Accordion.Header>
        <Accordion.Panel>
          {notFound ? (
            <HistoricalLog appName={appName} jobName={jobName} step={step} />
          ) : (
            <AsyncResource asyncState={state}>
              <StreamingLog
                eventStreamUrl={eventStreamUrl}
                copy
                download
                downloadCb={() => getLog({ appName, jobName, stepName: step.name, file: 'true' }, false).unwrap()}
              />
            </AsyncResource>
          )}
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  )
}
